import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState, AppThunk } from "../../app/store";
import { fetchgiftDeclarationsModule } from "./helpAndAssistantApi";

export interface GiftDeclarationsState {
  giftdeclarations: Array<any>;
  status: "idle" | "loading" | "failed";
}

const initialState: GiftDeclarationsState = {
  giftdeclarations: [],
  status: "idle",
};

export const GetgiftDeclarations = createAsyncThunk(
  "giftDeclarations/fetchgiftDeclarations",
  async (data:any) => {
    const response = await fetchgiftDeclarationsModule(data);
    return response;
  }
);

export const giftDeclarationsSlice = createSlice({
  name: "giftDeclarations",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetgiftDeclarations.pending, (state) => {
        state.status = "loading";
      })
      .addCase(GetgiftDeclarations.rejected, (state) => {
        state.status = "failed";
      })
      .addCase(GetgiftDeclarations.fulfilled, (state, action) => {
        state.status = "idle";
        state.giftdeclarations = action.payload.gift;
        
      });
  },
});

export const {} = giftDeclarationsSlice.actions;

export const selectgiftDeclarations = (state: RootState) => {
  return state.GiftDeclarations.giftdeclarations;
};

export default giftDeclarationsSlice.reducer;